//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[0,"FeaturesToGroupType",1,0],[0,"GeometryLocation",1,0],[0,"GroupByAttributes",1,0],[0,"GroupByMachiningAccessDirection",1,0],[1,"TopFaceCollector",0,"ScCollector",0]],[[["ftrs"],"SetInputFeatures",{},1,0],[["ftr_types"],"SetFeatureTypes",{},1,0],[["vecDirectionTags","dTolerance"],"SetMachiningAccessDirections",{},2,0],[[],"CreateFeatureGroups",{},0,0]],[]];
SPLM.CAM.GroupFeatures = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GroupFeatures";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.GroupFeatures.FeaturesToGroupTypes = Object.freeze({
    "All" : "All", "BelowTopFace" : "BelowTopFace", "SpecifyFeatures" : "SpecifyFeatures"});

export default SPLM;